import { DatePickerProps } from 'antd'
import dayjs, { Dayjs, UnitType, QUnitType } from 'dayjs'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'

dayjs.extend(quarterOfYear)

const datePickerDisabledDate =
  (
    compareDate: Dayjs | null | undefined,
    type: 'start' | 'end',
    compareUnit: UnitType | QUnitType,
    allowSameDate?: boolean
  ): NonNullable<DatePickerProps['disabledDate']> =>
  (date) => {
    if (!compareDate || !dayjs.isDayjs(compareDate)) return false // Ensure valid Dayjs

    if (type === 'start')
      return allowSameDate
        ? date.isAfter(compareDate, compareUnit)
        : date.isAfter(compareDate, compareUnit) ||
            date.isSame(compareDate, compareUnit)

    return allowSameDate
      ? date.isBefore(compareDate, compareUnit)
      : date.isBefore(compareDate, compareUnit) ||
          date.isSame(compareDate, compareUnit)
  }

export default datePickerDisabledDate
